export default __webpack_public_path__ + "static/media/multipad.564a64d1.png";